<template>
	<section class="section">
		<p v-if="error">{{ error }}</p>
		<h1 v-else class="title">Recipes tagged:
			<span v-for="(tag, index) in queryTags" :key="tag">
				<a v-bind:href="'/#/tags/' + tag">{{ tag }}</a>
				<span v-if="index != queryTags.length - 1"> &amp; </span>
			</span>
		</h1>
		<div class="tags">
			<a v-for="tag in tagSet" v-bind:key="tag"
				class="tag is-link is-warning"
				v-bind:href="'#' + $route.fullPath + ',' + tag">{{ tag }}</a>
		</div>
		<RecipeList v-bind:recipes="recipes">></RecipeList>
	</section>
</template>

<script>
	import RecipeList from '@/components/RecipeList.vue'

	import {db} from '@/variables.js'

	export default {
		props: {
			tags: String
		},
		components: {
			RecipeList
		},
		data: function () {
			return {
				queryTags: [],
				recipes: [],
				tagSet: new Set(),
				error: ""
			}
		},
		created: function() {
			this.fetchData()
		},
		watch: {
			// call fetchData again if the route changes
			'$route': 'fetchData'
		},
		methods: {
			fetchData: function() {
				var vm = this

				console.log(vm.$route)

				vm.error = ""

				vm.queryTags = vm.tags.split(',')
				var tagcount = vm.queryTags.length

				for( var idx = 0; idx < tagcount; idx++ )
				{
					vm.queryTags[idx] = vm.queryTags[idx].toLowerCase()
				}
				vm.queryTags.sort()


				if( tagcount > 3 )
				{
					vm.error = "Error: too many tags :("
				}
				else
				{
					var view = ''

					if( tagcount == 1 ){
						view = 'recipes/by_tag'
					}
					else if( tagcount == 2 )
					{
						view = 'recipes/by_tags_two'
					}
					else if( tagcount == 3)
					{
						view = 'recipes/by_tags_three'
					}

					var endkey = vm.queryTags.slice()
					endkey.push({})

					db.query( view, {
						startkey: vm.queryTags,
						endkey: endkey
					}).then( function( res ) {
						console.log( res )

						vm.tagSet.clear()

						var count = res.rows.length
						for( var row = 0; row < count; row++ )
						{
							var tags = res.rows[row].value.tags
							var recipeTagCount = tags.length
							for( var tagIndex = 0; tagIndex < recipeTagCount; tagIndex++ )
							{
								vm.tagSet.add( tags[tagIndex].toLowerCase() )
							}
						}

						for( var idx = 0; idx < tagcount; idx++ )
						{
							vm.tagSet.delete( vm.queryTags[idx] )
						}

						vm.recipes = res.rows

					}).catch( function( err ) {
						vm.recipes = []
						throw err
					})
				}
			}
		}
	}
</script>
